/** Client-side mirrors of the API's identity rules (the API remains the authority). */

export function mykadDigits(raw: string): string {
  return raw.replace(/[\s-]/g, '');
}

export function isCompleteMyKad(raw: string): boolean {
  return /^\d{12}$/.test(mykadDigits(raw));
}

/** Types "880412045531" as "880412-04-5531" while keeping partial input usable. */
export function formatMyKadInput(raw: string): string {
  const d = mykadDigits(raw).replace(/\D/g, '').slice(0, 12);
  if (d.length <= 6) return d;
  if (d.length <= 8) return `${d.slice(0, 6)}-${d.slice(6)}`;
  return `${d.slice(0, 6)}-${d.slice(6, 8)}-${d.slice(8)}`;
}

export function normalizePassportInput(raw: string): string {
  return raw.replace(/[\s-]/g, '').toUpperCase();
}

export function isPlausiblePassport(raw: string): boolean {
  return /^[A-Z0-9]{5,20}$/.test(normalizePassportInput(raw));
}
